/**
 * Lotus layout breakpoints (CSS px).
 *
 * Browser zoom shrinks layout viewport width (e.g. 125% ≈ ×0.8).
 * Former desktop floor was 1400px — at 110–125% zoom that flipped small
 * laptops into mobile chrome. Floor is 1400/1.25 = 1120 so desktop holds
 * through ~125% zoom on screens that were desktop at 100%.
 *
 * Real phones (≲500px) stay on mobile; styles for mobile are unchanged,
 * only the cutover width moved.
 */
export const LOTUS_DESKTOP_MIN_PX = 1120
export const LOTUS_MOBILE_MAX_PX = 1119

export const LOTUS_DESKTOP_MQ = `(min-width: ${LOTUS_DESKTOP_MIN_PX}px)`
export const LOTUS_MOBILE_MQ = `(max-width: ${LOTUS_MOBILE_MAX_PX}px)`

export function isLotusDesktopViewport(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia(LOTUS_DESKTOP_MQ).matches
}

export function isLotusMobileViewport(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia(LOTUS_MOBILE_MQ).matches
}
